import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export const Footer = () => {
  const footerLinks = [{
    title: 'Products',
    links: [{
      text: 'Pigeon Documents',
      url: 'https://www.pigeondocuments.com'
    }, {
      text: 'Pigeon Immigration',
      url: 'https://www.pigeonimmigration.com'
    }, {
      text: 'Pigeon Logistics',
      url: 'https://www.pigeononboarding.com'
    }, {
      text: 'Pigeon Subjectivities',
      url: 'https://www.pigeonsubjectivities.com'
    }]
  }, {
    title: 'Company',
    links: [{
      text: 'Privacy Policy',
      url: 'https://pigeondocuments.com/privacy-policy'
    }, {
      text: 'Terms of Service',
      url: 'https://pigeondocuments.com/terms-of-service'
    }]
  }, {
    title: 'Resources',
    links: [{
      text: 'API',
      url: 'https://docs.pigeondocuments.com/'
    }, {
      text: 'Support',
      url: 'https://pigeondocuments.com/support'
    }, {
      text: 'Email Us',
      url: 'mailto:info@pigeondocuments.com'
    }]
  }];
  return <footer className="bg-[#0B1220] text-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-449">
      <div className="max-w-7xl mx-auto" data-id="element-450">
        <div className="grid md:grid-cols-3 lg:grid-cols-3 gap-8" data-id="element-451">
          <div className="md:col-span-1 lg:col-span-1" data-id="element-452">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} data-id="element-453">
              <div className="flex items-center mb-4" data-id="element-454">
                <img src="https://i.imgur.com/EYcGnCY.png" alt="Pigeon Logo" className="h-10 w-10 mr-3" data-id="element-455" />
                <h2 className="text-xl font-bold flex flex-col -space-y-1" data-id="element-456">
                  <span className="text-white" data-id="element-457">Pigeon</span>
                  <span data-id="element-458">Subjectivities</span>
                </h2>
              </div>
              <p className="text-[#A0A8B8] mb-6" data-id="element-459">
                Automate your process and save thousands of hours.
              </p>
            </motion.div>
          </div>
          <div className="md:col-span-2 lg:col-span-2" data-id="element-460">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-461">
              {footerLinks.map((section, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.7,
              delay: index * 0.1
            }} data-id="element-462">
                  <h3 className="text-lg font-medium mb-4 text-white" data-id="element-463">
                    {section.title}
                  </h3>
                  <ul className="space-y-2" data-id="element-464">
                    {section.links.map((link, linkIndex) => <li key={linkIndex} data-id="element-465">
                        {link.internal ? <Link to={link.url} className="text-[#A0A8B8] hover:text-white transition-colors" data-id="element-466">
                            {link.text}
                          </Link> : <a href={typeof link === 'object' ? link.url : '#'} className="text-[#A0A8B8] hover:text-white transition-colors" data-id="element-467">
                            {typeof link === 'object' ? link.text : link}
                          </a>}
                      </li>)}
                  </ul>
                </motion.div>)}
            </div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-[#2A3041]" data-id="element-468">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-469">
            <p className="text-[#A0A8B8] text-sm" data-id="element-470">
              &copy; {new Date().getFullYear()} Pigeon Documents. All rights
              reserved.
            </p>
            <div className="mt-4 md:mt-0 flex items-center" data-id="element-471"></div>
          </div>
        </div>
      </div>
    </footer>;
};